/**
 * As duas abas do Início. Moram fora da tela porque a barra de endereço também fala delas:
 * a rota antiga `/visao-executiva` manda para a aba executiva, e um valor digitado à mão
 * que não existe cai na aba padrão em vez de deixar a tela sem painel nenhum.
 */

export const TAB_HOJE = 'hoje';
export const TAB_EXECUTIVA = 'executiva';

/** A aba que abre quando o endereço não pede nenhuma: o guia do dia. */
export const TAB_PADRAO = TAB_HOJE;

export const HOME_TAB_VALUES: ReadonlyArray<string> = [TAB_HOJE, TAB_EXECUTIVA];
